<script>
import SideMenuGroup                  from '../side-menu-group';
import ItemHelp                       from '../side-menu-item/help';
import ItemContact                    from '../side-menu-item/contact';
import ItemCsBlog                     from '../side-menu-item/cs-blog';
import ItemEnquete                    from '../side-menu-item/enquete';
import ItemPremiumCancel              from '../side-menu-item/premium-cancel';
import ItemServiceList                from '../side-menu-item/service-list';
import ItemApproachAboutReviewRanking from '../side-menu-item/approach-about-review-ranking'

export default {
  name  : 'side-menu-group-customer-support',
  mixins: [SideMenuGroup],
  data  : function() {
    return {
      menuItems: [
        ItemPremiumCancel,
        ItemServiceList,
        ItemHelp,
        ItemContact,
        ItemCsBlog,
        ItemApproachAboutReviewRanking,
        ItemEnquete,
      ],
      separator: true,
      analytics: { label: 'side_menu_group_cs' },
    };
  },
};
</script>
